import Color from 'color'
import seedrandom from 'seedrandom'
const MIN_CONTRAST = 2.5

let bgColor = null

const drawName = (paper, typeface, name, color, maxWidth, maxHeight) => {
  let path = typeface.getPath(name, 0, 0, 36)
  let text = new paper.CompoundPath(path.toPathData())
  text.fillColor = color
  text.strokeWidth = 0
  let widthScale = maxWidth/text.bounds.width
  let heightScale = maxHeight/text.bounds.height
  text.scale(Math.min(widthScale, heightScale))
  return text
}

const drawBG = (paper, width, height, bgColor) => {
  let bg = new paper.Path.Rectangle({
      point: [0, 0],
      size: [width, height],
      selected: false,
      fillColor: bgColor
  })
  return bg
}

const drawGradient = (fillOrStroke, obj, fromColor, toColor, origin, destination) => {
  if (fillOrStroke === 'fill') {
    obj.fillColor = {
      gradient: {
        stops: [fromColor, toColor],
      },
      origin: origin,
      destination: destination
    }
  }
  else {
    obj.strokeColor = {
      gradient: {
        stops: [fromColor, toColor],
      },
      origin: origin,
      destination: destination
    }
  }
}

const goodContrast = (first, second) => {
  let firstColor = Color(first)
  let contrast = firstColor.contrast(Color(second))
  if (contrast < MIN_CONTRAST) return false
  return true
}

const analizeName = (name) => {
  let displayName = true
  let initials = name.match(/\S+/g) || ['']
  let initialChar = ''
  if (initials[0].length > 0) {
    initialChar = initials[0][0]
    if (initials.length === 1 && initials[0].length <= 3) {
      initialChar = initials[0] // The initials will be the full world
      displayName = false
    }
  }
  if (initials.length === 2) {
    if (initials[1].length > 4) {
      initialChar += initials[1][0]
    }
  }

  return {displayName, initialChar}
}

const cleanUpSVG = (currentChildren) => {
  if (currentChildren.content === "http://thenounproject.com") {
    currentChildren.parent.remove()
    return true
  }
  if (currentChildren.hasChildren) {
    if (currentChildren.hasChildren()) {
      for (let i = 0; i < currentChildren.children.length; i++) {
        if (cleanUpSVG(currentChildren.children[i])) {
          return false
        }
      }
    }
  }
}


//****************************************************************************//
export const generativeLayout001 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let maxHeight = slogan ? 2*height/3 : height
  let brandText = drawName(paper, typeface, logoName, brandColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandText.bounds.height/6 // How much space between slogan and text
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor, width, brandText.bounds.height)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // Centralize and scale both
  let widthScale = width/group.bounds.width
  let heightScale = height/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0011 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let maxHeight = slogan ? 2*height/3 : height
  let brandText = drawName(paper, typeface, logoName, brandColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandText.bounds.height/6 // How much space between slogan and text
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor,  Math.min(2*width/3, brandText.bounds.width), brandText.bounds.height)
    sloganText.bounds.right = brandText.bounds.right
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // Centralize and scale both
  let widthScale = width/group.bounds.width
  let heightScale = height/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0012 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let maxHeight = slogan ? 2*height/3 : height
  let brandText = drawName(paper, typeface, logoName, brandColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandText.bounds.height/6 // How much space between slogan and text
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor,  Math.min(2*width/3, brandText.bounds.width), brandText.bounds.height)
    sloganText.bounds.left = brandText.bounds.left
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // Centralize and scale both
  let widthScale = width/group.bounds.width
  let heightScale = height/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0013 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let maxHeight = slogan ? 2*height/3 : height
  let brandText = drawName(paper, typeface, logoName, brandColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandText.bounds.height/6 // How much space between slogan and text
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor,  Math.min(2*width/3, brandText.bounds.width), brandText.bounds.height)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // Centralize and scale both
  let widthScale = width/group.bounds.width
  let heightScale = height/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0014 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let maxHeight = slogan ? 2*height/3 : height
  let brandText = drawName(paper, typeface, logoName, brandColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor, width, 2*brandText.bounds.height/3)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // Centralize and scale both
  group.fitBounds(paper.view.bounds)
  group.bounds.center = (width/2, height/2)
  group.name = "logo"
  brandText.smooth()

  if (parameters.gradient) {
    drawGradient("fill", brandText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout002 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor) && parameters.fill) parameters.subtract = true

  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }
  if (!parameters.fill) parameters.stroke = true
  if (parameters.stroke) parameters.fill = false

  let shapeStroke = parameters.stroke ? width/30 : 0
  let borderShape = width/7

  // Brand name
  let maxHeight = slogan ? height/3 : 2*height/3
  let brandText = drawName(paper, typeface, logoName, textColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let sloganText = null
  let frame = null
  let paddingBetween = brandText.bounds.height/6 // How much space between slogan and text

  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, textColor, width, ((height - brandText.bounds.height - 2*paddingBetween)))
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
    group.bounds.center = (width/2, height/2)
  }

  // eslint-disable-next-line
  frame = new paper.Path.Rectangle({
    point: [group.bounds.left  - (shapeStroke/2 + borderShape), group.bounds.top - (shapeStroke/2 + borderShape)],
    size: [group.bounds.width + (shapeStroke + 2*borderShape), group.bounds.height + (shapeStroke + 2*borderShape)],
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    strokeWidth: shapeStroke,
    strokeScaling: true,
    fillColor: parameters.fill ? fillColor : null
  })

  // brandText.bounds.selected = true
  // sloganText.bounds.selected = true
  // frame.bounds.selected = true
  frame.name = "frame"
  group.addChild(frame)
  frame.sendToBack()
  let widthScale = width/(group.bounds.width + 2*shapeStroke)
  let heightScale = height/(group.bounds.height + 2*shapeStroke)
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (!parameters.subtract) brandText.blendMode = 'negation'
    if (sloganText) {
      drawGradient("fill", sloganText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
      if (!parameters.subtract) sloganText.blendMode = 'negation'
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
  }

  if (parameters.subtract) {
    let allTextPath = new paper.CompoundPath()
    if (brandText) allTextPath.addChild(brandText)
    if (sloganText) allTextPath.addChild(sloganText)
    let subtraction = frame.subtract(allTextPath)
    subtraction.name = 'icon'
    group.addChild(subtraction)

    allTextPath.remove()
    if (sloganText) sloganText.remove()
    if (brandText) brandText.remove()
    frame.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}

//****************************************************************************//
export const generativeLayout0021 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor) && parameters.fill) parameters.subtract = true

  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }
  if (!parameters.fill) parameters.stroke = true
  if (parameters.stroke) parameters.fill = false

  let shapeStroke = parameters.stroke ? width/30 : 0
  let borderShape = width/7

  // Brand name
  let maxHeight = slogan ? height/3 : 2*height/3
  let brandText = drawName(paper, typeface, logoName, textColor, width, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let sloganText = null
  let frame = null
  let paddingBetween = brandText.bounds.height/6 // How much space between slogan and text

  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, textColor, width, ((height - brandText.bounds.height - 2*paddingBetween)))
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
    group.bounds.center = (width/2, height/2)
  }

  let radius = (Math.sqrt(group.bounds.width*group.bounds.width + group.bounds.height*group.bounds.height))/2 + shapeStroke + borderShape
  // eslint-disable-next-line
  frame = new paper.Path.Circle({
    center: [width/2, height/2],
    radius: radius,
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    strokeWidth: shapeStroke,
    strokeScaling: true,
    fillColor: parameters.fill ? fillColor : null
  })

  // brandText.bounds.selected = true
  // sloganText.bounds.selected = true
  // frame.bounds.selected = true
  frame.name = "frame"
  group.addChild(frame)
  frame.sendToBack()
  let widthScale = width/(group.bounds.width + 2*shapeStroke)
  let heightScale = height/(group.bounds.height + 2*shapeStroke)
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (!parameters.subtract) brandText.blendMode = 'negation'
    if (sloganText) {
      drawGradient("fill", sloganText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
      if (!parameters.subtract) sloganText.blendMode = 'negation'
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
  }

  if (parameters.subtract) {
    let allTextPath = new paper.CompoundPath()
    if (brandText) allTextPath.addChild(brandText)
    if (sloganText) allTextPath.addChild(sloganText)
    let subtraction = frame.subtract(allTextPath)
    subtraction.name = 'icon'
    group.addChild(subtraction)

    allTextPath.remove()
    if (sloganText) sloganText.remove()
    if (brandText) brandText.remove()
    frame.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0022 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  parameters.fill = true
  parameters.stroke = false
  if(!goodContrast(fillColor, textColor) && parameters.fill) parameters.subtract = true

  // Brand name
  let maxHeight = slogan ? height/3 : 2*height/3
  let brandText = drawName(paper, typeface, logoName, textColor, 2*width/3, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let sloganText = null
  let frame = null
  let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text

  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, textColor, 2*width/3 , ((height - brandText.bounds.height - 2*paddingBetween)/2))
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }
  group.bounds.center = (width/2, height/2)

  // eslint-disable-next-line
  let rng = seedrandom(logoName+slogan)
  frame = new paper.Path.RegularPolygon({
    center: [width/2, height/2],
    radius: width,
    sides: 3,
    rotation: Math.floor(rng()*width),
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    strokeWidth: 0,
    strokeScaling: true,
    fillColor: parameters.fill ? fillColor : null
  })
  frame.smooth()
  frame.fitBounds(paper.view.bounds)
  frame.name = "frame"
  group.addChild(frame)
  frame.sendToBack()
  group.name = "logo"
  group.fitBounds(frame.bounds)

  if (parameters.gradient) {
    drawGradient("fill", brandText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (!parameters.subtract) brandText.blendMode = 'negation'
    if (sloganText) {
      drawGradient("fill", sloganText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
      if (!parameters.subtract) sloganText.blendMode = 'negation'
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
  }

  if (parameters.subtract) {
    group.blendMode = 'multiply'
    let allTextPath = new paper.CompoundPath()
    if (brandText) allTextPath.addChild(brandText)
    if (sloganText) allTextPath.addChild(sloganText)
    let subtraction = frame.subtract(allTextPath)
    subtraction.name = 'icon'
    group.addChild(subtraction)

    allTextPath.remove()
    if (sloganText) sloganText.remove()
    if (brandText) brandText.remove()
    frame.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0023 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor) && parameters.fill) parameters.subtract = true

  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }
  if (!parameters.fill) parameters.stroke = true
  if (parameters.stroke) parameters.fill = false

  // Brand name
  let maxHeight = slogan ? height/3 : 2*height/3
  let brandText = drawName(paper, typeface, logoName, textColor, 2*width/3, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let sloganText = null
  let frame = null
  let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text

  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, textColor, 2*width/3 , ((height - brandText.bounds.height - 2*paddingBetween)/2))
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }
  group.bounds.center = (width/2, height/2)

  let shapeStroke = parameters.stroke ? 7 : 0
  // eslint-disable-next-line
  let rng = seedrandom(logoName+slogan)
  frame = new paper.Path.RegularPolygon({
    center: [width/2, height/2],
    radius: width,
    sides: 3,
    rotation: Math.floor(rng()*width),
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    strokeWidth: shapeStroke,
    strokeScaling: true,
    fillColor: parameters.fill ? fillColor : null
  })
  frame.smooth()
  let widthScale = (width-2)/(frame.bounds.width + 2*shapeStroke)
  let heightScale = (height-2)/(frame.bounds.height + 2*shapeStroke)
  frame.scale(Math.min(widthScale, heightScale))
  frame.bounds.center = (width/2, height/2)
  frame.name = "frame"
  group.addChild(frame)
  frame.sendToBack()

  let secondFrame = new paper.Path.RegularPolygon({
    center: [width/2, height/2],
    radius: width,
    sides: 3,
    rotation: Math.floor(rng()*width),
    selected: false,
    strokeColor: parameters.stroke ? fillColor : null,
    strokeWidth: shapeStroke,
    strokeScaling: true,
    fillColor: parameters.fill ? textColor : null
  })
  secondFrame.smooth()
  widthScale = (width-2)/(secondFrame.bounds.width + 2*shapeStroke)
  heightScale = (height-2)/(secondFrame.bounds.height + 2*shapeStroke)
  secondFrame.scale(Math.min(widthScale, heightScale))
  secondFrame.bounds.center = (width/2, height/2)
  secondFrame.name = "secondFrame"
  group.addChild(secondFrame)
  secondFrame.sendToBack()

  frame.opacity = 0.5
  secondFrame.opacity = 0.5
  group.name = "logo"
  // group.fitBounds(frame.bounds)

  if (parameters.subtract) {
    let allTextPath = new paper.CompoundPath()
    if (brandText) allTextPath.addChild(brandText)
    if (sloganText) allTextPath.addChild(sloganText)
    let subtraction = frame.subtract(allTextPath)
    subtraction.name = 'icon'
    group.addChild(subtraction)

    allTextPath.remove()
    if (sloganText) sloganText.remove()
    if (brandText) brandText.remove()
    frame.remove()
  }

  if (parameters.gradient) {
    drawGradient("fill", brandText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (!parameters.subtract) brandText.blendMode = 'add'
    if (sloganText) {
      drawGradient("fill", sloganText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
      if (!parameters.subtract) sloganText.blendMode = 'add'
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
      drawGradient("fill", secondFrame, fillColor, textColor, secondFrame.bounds.left, secondFrame.bounds.right)
    }
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
      drawGradient("stroke", secondFrame, fillColor, textColor, secondFrame.bounds.left, secondFrame.bounds.right)
    }
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0024 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  parameters.fill = true
  parameters.stroke = false
  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor) && parameters.fill) parameters.subtract = true

  // Brand name
  let maxHeight = slogan ? height/3 : 2*height/3
  let brandText = drawName(paper, typeface, logoName, textColor, 2*width/3, maxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let sloganText = null
  let frame = null
  let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text

  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, textColor, 2*width/3 , ((height - brandText.bounds.height - 2*paddingBetween)/2))
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText.bounds.bottom + paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }
  group.bounds.center = (width/2, height/2)

  // eslint-disable-next-line
  let rng = seedrandom(logoName+slogan)
  frame = new paper.Path.RegularPolygon({
    center: [width/2, height/2],
    radius: width,
    sides: 7,
    rotation: Math.floor(rng()*width),
    selected: false,
    strokeColor: null,
    strokeWidth: 0,
    strokeScaling: true,
    fillColor: parameters.fill ? fillColor : null
  })
  frame.smooth()
  let widthScale = (width-2)/(frame.bounds.width)
  let heightScale = (height-2)/(frame.bounds.height)
  frame.scale(Math.min(widthScale, heightScale))
  frame.bounds.center = (width/2, height/2)
  frame.name = "frame"
  group.addChild(frame)
  frame.sendToBack()

  let secondFrame = new paper.Path.RegularPolygon({
    center: [width/2, height/2],
    radius: width/2,
    sides: 3,
    rotation: Math.floor(rng()*width),
    selected: false,
    strokeColor: null,
    strokeWidth: 0,
    strokeScaling: true,
    fillColor: parameters.fill ? textColor : null
  })
  secondFrame.smooth()
  secondFrame.bounds.center = (width/2, height/2)
  secondFrame.name = "secondFrame"
  group.addChild(secondFrame)
  secondFrame.sendToBack()
  group.name = "logo"

  if (parameters.gradient) {
    drawGradient("fill", brandText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (sloganText) {
      drawGradient("fill", sloganText, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
      drawGradient("fill", secondFrame, fillColor, textColor, secondFrame.bounds.left, secondFrame.bounds.right)
    }
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
      drawGradient("stroke", secondFrame, fillColor, textColor, secondFrame.bounds.left, secondFrame.bounds.right)
    }
  }

  let subtraction = frame.subtract(secondFrame)
  subtraction.name = 'icon'
  subtraction.opacity = 0.5
  group.addChild(subtraction)

  secondFrame.remove()
  frame.remove()

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout003 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!typeface) return
  if (!secondTypeface) return

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor)) {
    if (parameters.gradient) parameters.subtract = true
    else if (parameters.fill) parameters.fill = false
  }

  if (!parameters.fill) parameters.stroke = true
  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }

  let {displayName, initialChar} = analizeName(logoName)

  let group = new paper.Group()

  // *** Brand name ***
  let brandText
  if (displayName) {
    brandText = drawName(paper, typeface, logoName, textColor, width, height/3)
    brandText.bounds.centerX = width/2
    brandText.bounds.bottom = height
    brandText.name = "brand-name"
    group.addChild(brandText)
  }

  // *** Slogan ***
  let sloganText
  if (slogan) {
    let sloganMaxHeight = brandText ? brandText.bounds.height : height/3
    sloganText = drawName(paper, typeface, slogan, fillColor, width, sloganMaxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height // Position the slogan at the bottom of the canvas
    if (brandText) brandText.bounds.bottom = sloganText.bounds.top - brandText.bounds.height/3
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Top rectangle ***
  let size = Math.min(width, height)
  if (brandText && sloganText) size = Math.min(2*group.bounds.height, group.bounds.width/2)
  else if (brandText || sloganText) size = Math.min(4*group.bounds.height, group.bounds.width/2)
  let stroke = parameters.stroke ? size/30 : 0
  size -= stroke
  // eslint-disable-next-line
  let frame = new paper.Path.Rectangle({
    point: [width/2 - size/2, 0],
    size: [size, size],
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    fillColor: parameters.fill ? fillColor : null,
    strokeScaling: true,
    strokeWidth: stroke
  })
  frame.bounds.bottom = group.bounds.top - stroke/2 - group.bounds.height/3

  // *** Inicials inside the recatngle ***
  let initialLetter
  if (brandText || sloganText) initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, frame.bounds.width/2, frame.bounds.height/2)
  else initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, 2*frame.bounds.width/3, 2*frame.bounds.height/3)
  initialLetter.position = new paper.Point(frame.bounds.centerX, frame.bounds.centerY)

  frame.sendToBack()
  frame.name = "icon"
  group.addChild(frame)
  initialLetter.name = "brand-initials"
  group.addChild(initialLetter)

  let widthScale = (width - stroke)/group.bounds.width
  let heightScale = (height - stroke)/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    if (brandText) drawGradient("fill", brandText, textColor, fillColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, textColor, fillColor, sloganText.bounds.left, sloganText.bounds.right)
    drawGradient("fill", initialLetter, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
      if (!parameters.subtract) initialLetter.blendMode = 'negation'
    }
  }

  if (parameters.subtract) {
    let subtraction = frame.subtract(initialLetter)
    subtraction.name = 'icon'
    group.addChild(subtraction)
    frame.remove()
    initialLetter.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}

//****************************************************************************//

export const generativeLayout0031 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!typeface) return
  if (!secondTypeface) return

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor)) {
    if (parameters.gradient) parameters.subtract = true
    else if (parameters.fill) parameters.fill = false
  }

  if (!parameters.fill) parameters.stroke = true
  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }

  let {displayName, initialChar} = analizeName(logoName)

  let group = new paper.Group()

  // *** Brand name ***
  let brandText
  if (displayName) {
    brandText = drawName(paper, typeface, logoName, textColor, width, height/3)
    brandText.bounds.centerX = width/2
    brandText.bounds.bottom = height
    brandText.name = "brand-name"
    group.addChild(brandText)
  }

  // *** Slogan ***
  let sloganText
  if (slogan) {
    let sloganMaxHeight = brandText ? brandText.bounds.height : height/3
    sloganText = drawName(paper, typeface, slogan, fillColor, width, sloganMaxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height // Position the slogan at the bottom of the canvas
    if (brandText) brandText.bounds.bottom = sloganText.bounds.top - brandText.bounds.height/3
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Top rectangle or circle ***
  let size = Math.min(width, height)
  if (brandText && sloganText) size = Math.min(2*group.bounds.height, group.bounds.width/2)
  else if (brandText || sloganText) size = Math.min(4*group.bounds.height, group.bounds.width/2)
  let stroke = parameters.stroke ? size/30 : 0
  size -= stroke
  let radius = size/2
  // eslint-disable-next-line
  let frame = new paper.Path.Circle({
    center: [width/2, 0],
    radius: radius,
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    fillColor: parameters.fill ? fillColor : null,
    strokeScaling: true,
    strokeWidth: stroke
  })
  frame.bounds.bottom = group.bounds.top - stroke/2 - group.bounds.height/3

  // *** Inicials inside the circle ***
  // Scale the initial letter to use half of the frame
  let initialLetter
  if (brandText || sloganText) initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, frame.bounds.width/2, frame.bounds.height/2)
  else initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, 2*frame.bounds.width/3, 2*frame.bounds.height/3)
  initialLetter.position = new paper.Point(frame.bounds.centerX, frame.bounds.centerY)

  frame.sendToBack()
  frame.name = "icon"
  group.addChild(frame)
  initialLetter.name = "brand-initials"
  group.addChild(initialLetter)

  let widthScale = (width - stroke)/group.bounds.width
  let heightScale = (height - stroke)/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    if (brandText) drawGradient("fill", brandText, textColor, fillColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, textColor, fillColor, sloganText.bounds.left, sloganText.bounds.right)
    drawGradient("fill", initialLetter, fillColor, textColor, frame.bounds.left, frame.bounds.right)
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
      if (!parameters.subtract) initialLetter.blendMode = 'negation'
    }
  }

  if (parameters.subtract) {
    let subtraction = frame.subtract(initialLetter)
    subtraction.name = 'icon'
    group.addChild(subtraction)
    frame.remove()
    initialLetter.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}

//****************************************************************************//

export const generativeLayout0032 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!typeface) return
  if (!secondTypeface) return

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor)) {
    if (parameters.gradient) parameters.subtract = true
    else if (parameters.fill) parameters.fill = false
  }

  if (!parameters.fill) parameters.stroke = true
  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }
  if (parameters.gradient && parameters.fill) {
    parameters.stroke = false
  }

  let {displayName, initialChar} = analizeName(logoName)

  let group = new paper.Group()
  // *** Brand name ***
  let brandText
  if (displayName) {
    brandText = drawName(paper, typeface, logoName, textColor, width, height/3)
    brandText.bounds.centerX = width/2
    brandText.bounds.bottom = height
    brandText.name = "brand-name"
    group.addChild(brandText)
  }

  // *** Slogan ***
  let sloganText
  if (slogan) {
    let sloganMaxHeight = brandText ? brandText.bounds.height : height/3
    sloganText = drawName(paper, typeface, slogan, fillColor, width, sloganMaxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height // Position the slogan at the bottom of the canvas
    if (brandText) {
      brandText.bounds.bottom = sloganText.bounds.top - brandText.bounds.height/3
      sloganText.bounds.left = brandText.bounds.left
    }
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Left circle ***
  let size = Math.min(width, height)
  if (brandText && sloganText) size = Math.min(2*group.bounds.height, 2*group.bounds.width/3)
  else if (brandText || sloganText) size = Math.min(5*group.bounds.height, 2*group.bounds.width/3)

  let stroke = parameters.stroke ? size/30 : 0
  size -= stroke
  let radius = size/2
  // eslint-disable-next-line
  let frame = new paper.Path.Circle({
    center: [width/2, stroke/2 + radius],
    radius: radius,
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    fillColor: parameters.fill ? fillColor : null,
    strokeScaling: true,
    strokeWidth: stroke
  })

  frame.bounds.right = group.bounds.left - stroke/2 - group.bounds.height/3
  frame.bounds.centerY = group.bounds.centerY

  // *** Inicials inside the circle ***
  // Scale the initial letter to use half of the frame
  let initialLetter
  if (brandText || sloganText) initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, frame.bounds.width/2, frame.bounds.height/2)
  else initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, 2*frame.bounds.width/3, 2*frame.bounds.height/3)
  initialLetter.position = new paper.Point(frame.bounds.centerX, frame.bounds.centerY)

  frame.sendToBack()
  frame.name = "icon"
  group.addChild(frame)
  initialLetter.name = "brand-initials"
  group.addChild(initialLetter)

  let widthScale = (width - stroke)/group.bounds.width
  let heightScale = (height - stroke)/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    if (brandText) drawGradient("fill", brandText, textColor, fillColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, textColor, fillColor, sloganText.bounds.left, sloganText.bounds.right)
    drawGradient("fill", initialLetter, fillColor, textColor, frame.bounds.left, frame.bounds.right + frame.bounds.width)
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right + frame.bounds.width)
      if (!parameters.subtract) initialLetter.blendMode = 'negation'
    }
  }

  if (parameters.subtract) {
    let subtraction = frame.subtract(initialLetter)
    subtraction.name = 'icon'
    group.addChild(subtraction)
    frame.remove()
    initialLetter.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}

//****************************************************************************//

export const generativeLayout0033 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!typeface) return
  if (!secondTypeface) return

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }
  if(!goodContrast(fillColor, textColor)) {
    if (parameters.gradient) parameters.subtract = true
    else if (parameters.fill) parameters.fill = false
  }

  if (!parameters.fill) parameters.stroke = true
  if (parameters.subtract) {
    parameters.fill = true
    parameters.stroke = false
  }
  if (parameters.gradient && parameters.fill) {
    parameters.stroke = false
  }

  let {displayName, initialChar} = analizeName(logoName)

  let group = new paper.Group()
  // *** Brand name ***
  let brandText
  if (displayName) {
    brandText = drawName(paper, typeface, logoName, textColor, width, height/3)
    brandText.bounds.centerX = width/2
    brandText.bounds.bottom = height
    brandText.name = "brand-name"
    group.addChild(brandText)
  }

  // *** Slogan ***
  let sloganText
  if (slogan) {
    let sloganMaxHeight = brandText ? brandText.bounds.height : height/3
    sloganText = drawName(paper, typeface, slogan, fillColor, width, sloganMaxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height // Position the slogan at the bottom of the canvas
    if (brandText) {
      brandText.bounds.bottom = sloganText.bounds.top - brandText.bounds.height/3
      sloganText.bounds.left = brandText.bounds.left
    }
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }


  // *** Left rectangle ***
  let size = Math.min(width, height)
  if (brandText && sloganText) size = Math.min(2*group.bounds.height, group.bounds.width)
  else if (brandText || sloganText) size = Math.min(5*group.bounds.height, group.bounds.width)
  let stroke = parameters.stroke ? size/30 : 0
  size -= stroke
  // eslint-disable-next-line
  let frame = new paper.Path.Rectangle({
    point: [width/2 - size/2, 0 + stroke/2],
    size: [size, size],
    selected: false,
    strokeColor: parameters.stroke ? textColor : null,
    fillColor: parameters.fill ? fillColor : null,
    strokeScaling: true,
    strokeWidth: stroke
  })

  frame.bounds.right = group.bounds.left - stroke/2 - group.bounds.height/3
  frame.bounds.centerY = group.bounds.centerY

  // *** Inicials inside the rectangle ***
  // Scale the initial letter to use half of the frame
  let initialLetter
  if (brandText || sloganText) initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, frame.bounds.width/2, frame.bounds.height/2)
  else initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), textColor, 2*frame.bounds.width/3, 2*frame.bounds.height/3)
  initialLetter.position = new paper.Point(frame.bounds.centerX, frame.bounds.centerY)

  frame.sendToBack()
  frame.name = "icon"
  group.addChild(frame)
  initialLetter.name = "brand-initials"
  group.addChild(initialLetter)

  let widthScale = (width - stroke)/group.bounds.width
  let heightScale = (height - stroke)/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    if (brandText) drawGradient("fill", brandText, textColor, fillColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, textColor, fillColor, sloganText.bounds.left, sloganText.bounds.right)
    drawGradient("fill", initialLetter, fillColor, textColor, frame.bounds.left, frame.bounds.right + frame.bounds.width)
    if (parameters.stroke) {
      drawGradient("stroke", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right)
    }
    if (parameters.fill) {
      drawGradient("fill", frame, textColor, fillColor, frame.bounds.left, frame.bounds.right + frame.bounds.width)
      if (!parameters.subtract) initialLetter.blendMode = 'negation'
    }
  }

  if (parameters.subtract) {
    let subtraction = frame.subtract(initialLetter)
    subtraction.name = 'icon'
    group.addChild(subtraction)
    frame.remove()
    initialLetter.remove()
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}

//****************************************************************************//
export const generativeLayout0034 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!typeface) return
  if (!secondTypeface) return

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.gradient = false
  }

  let {displayName, initialChar} = analizeName(logoName)

  let group = new paper.Group()
  // *** Brand name ***
  let brandText
  if (displayName) {
    brandText = drawName(paper, typeface, logoName, textColor, width, height/3)
    brandText.bounds.centerX = width/2
    brandText.bounds.bottom = height
    brandText.name = "brand-name"
    group.addChild(brandText)
  }

  // *** Slogan ***
  let sloganText
  if (slogan) {
    let sloganMaxHeight = brandText ? 2*brandText.bounds.height/3 : height/3
    sloganText = drawName(paper, typeface, slogan, fillColor, width, sloganMaxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height // Position the slogan at the bottom of the canvas
    if (brandText) brandText.bounds.bottom = sloganText.bounds.top - brandText.bounds.height/3
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  let sizeX = width
  let sizeY = height
  if (brandText || sloganText) {
    sizeX = (!brandText || !sloganText) ? group.bounds.width : group.bounds.width/2
    sizeY = (!brandText || !sloganText) ? 3*group.bounds.height : 2*group.bounds.height
  }
  let initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), fillColor, sizeX, sizeY)
  initialLetter.bounds.centerX = group.bounds.centerX
  if (!brandText || !sloganText) initialLetter.bounds.bottom = group.bounds.top - group.bounds.height
  else initialLetter.bounds.bottom = group.bounds.top - group.bounds.height/2
  initialLetter.name = "brand-initials"
  group.addChild(initialLetter)
  group.name = "logo"
  group.fitBounds(paper.view.bounds)

  if (parameters.gradient) {
    drawGradient("fill", initialLetter, textColor, fillColor, initialLetter.bounds.left, initialLetter.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0035 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!typeface) return
  if (!secondTypeface) return

  let textColor = colorPalette[1] || colorPalette[0]
  let fillColor = colorPalette[0]
  if (!textColor || !fillColor) {
    parameters.gradient = false
  }

  let {displayName, initialChar} = analizeName(logoName)

  let group = new paper.Group()
  // *** Brand name ***
  let brandText
  if (displayName) {
    brandText = drawName(paper, typeface, logoName, textColor, width, height/3)
    brandText.bounds.centerX = width/2
    brandText.bounds.bottom = height
    brandText.name = "brand-name"
    group.addChild(brandText)
  }

  // *** Slogan ***
  let sloganText
  if (slogan) {
    let sloganMaxHeight = brandText ? 2*brandText.bounds.height/3 : height/3
    sloganText = drawName(paper, typeface, slogan, fillColor, width, sloganMaxHeight)
    if (brandText) sloganText.bounds.left = brandText.bounds.left
    else sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height // Position the slogan at the bottom of the canvas
    if (brandText) brandText.bounds.bottom = sloganText.bounds.top - brandText.bounds.height/3
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  let sizeX = width
  let sizeY = height
  if (brandText || sloganText) {
    sizeX = (!brandText || !sloganText) ? group.bounds.width : group.bounds.width/2
    sizeY = 2*group.bounds.height
  }
  let initialLetter = drawName(paper, secondTypeface, initialChar.toUpperCase(), fillColor, sizeX, sizeY)
  initialLetter.bounds.centerY = group.bounds.centerY
  initialLetter.bounds.right = group.bounds.left - group.bounds.height/2
  initialLetter.name = "brand-initials"
  group.addChild(initialLetter)
  group.name = "logo"
  group.fitBounds(paper.view.bounds)

  if (parameters.gradient) {
    drawGradient("fill", initialLetter, textColor, fillColor, initialLetter.bounds.left, initialLetter.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//

export const generativeLayout004 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]
  if (!parameters.fill) parameters.stroke = true
  // parameters.fill = false
  // parameters.stroke = true

  // *** Brand name ***
  let brandText = drawName(paper, typeface, logoName, brandColor, width, height/3)
  brandText.bounds.center = (width/2, height/2)
  brandText.bounds.bottom = height
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text

  // *** Slogan ***
  let sloganText = null
  let frame = null
  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor, width, (2*brandText.bounds.height/3))
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height
    brandText.bounds.bottom = sloganText.bounds.top - paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Generative ***
  let frameSpace = Math.min(group.bounds.top - paddingBetween, 3*group.bounds.height)
  let stroke = group.bounds.height/50
  if (stroke < 1) stroke = 1
  frame = new paper.Path()
  let pointX, pointY, pointXF, pointYF, firstStart, firstFinal
  let rng = seedrandom(logoName+slogan)
  for (let i = 0; i < frameSpace/50; i ++) {
    pointX = Math.floor(rng() * width)
    pointY = Math.floor(rng() * frameSpace)
    pointXF = Math.floor(rng() * width)
    pointYF = Math.floor(rng() * frameSpace)
    frame.add(new paper.Point(pointX, pointYF))
    frame.add(new paper.Point(pointXF, pointY))
    if (i === 0) {
      firstStart = new paper.Point(pointX, pointYF)
      firstFinal = new paper.Point(pointXF, pointY)
    }
  }
  if (firstStart) frame.add(firstStart)
  if (firstFinal) frame.add(firstFinal)
  frame.smooth()
  let widthScale = width/frame.bounds.width
  let heightScale = frameSpace/frame.bounds.height
  // frame.scale(Math.min(widthScale, heightScale))
  frame.bounds.bottom = group.bounds.top - paddingBetween
  frame.bounds.centerX = width/2
  frame.sendToBack()
  frame.name = "icon"
  group.addChild(frame)

  widthScale = (width - stroke)/group.bounds.width
  heightScale = (height - stroke)/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  frame.strokeColor = sloganColor
  frame.strokeWidth = stroke
  frame.strokeScaling = true
  frame.strokeColor.alpha = 1
  frame.opacity = 0.8
  if (parameters.fill) frame.fillColor = brandColor
  if (parameters.gradient) {
    drawGradient("stroke", frame, sloganColor, brandColor, frame.bounds.left, frame.bounds.right)
    if (parameters.fill) drawGradient("fill", frame, sloganColor, brandColor, frame.bounds.left, frame.bounds.right)
    drawGradient("fill", brandText, brandColor, sloganColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, sloganText.bounds.left, sloganText.bounds.right)
  }

  // brandText.bounds.selected = true
  // if (sloganText) sloganText.bounds.selected = true
  // frame.bounds.selected = true

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//

export const generativeLayout005 = (params) => {
  let { asset, paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!asset) return generativeLayout003(params)
  cleanUpSVG(asset)
  parameters.stroke = false
  parameters.fill = true

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]
  if (!brandColor || !sloganColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }

  // *** Brand name ***
  let nameMaxHeight = slogan ? height/4 : height/3
  let brandText = drawName(paper, typeface, logoName, null, width, nameMaxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.bounds.bottom = height
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let paddingBetween = slogan ? brandText.bounds.height/3 : brandText.bounds.height/2 // How much space between slogan and text
  paddingBetween = Math.floor(paddingBetween)
  // *** Slogan ***
  let sloganText = null
  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, null, width, brandText.bounds.height)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height
    brandText.bounds.bottom = sloganText.bounds.top - paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Symbol ***
  let instance = asset
  let symbolSpace = Math.floor(group.bounds.top - paddingBetween)
  // let widthScale = (2*width/3)/instance.bounds.width
  let widthScale = (width)/instance.bounds.width
  let heightScale = Math.min(3*group.bounds.height, symbolSpace)/instance.bounds.height
  instance.scale(Math.min(widthScale, heightScale))
  if (symbolSpace > (instance.bounds.height + paddingBetween)) instance.bounds.bottom = symbolSpace - paddingBetween
  else instance.bounds.bottom = symbolSpace
  if (instance.bounds.top < 0) instance.bounds.top = 0
  instance.bounds.centerX = width/2
  instance.sendToBack()
  instance.name = "icon"
  group.addChild(instance)

  group.name = "logo"
  group.fitBounds(paper.view.bounds)

  if (brandText) brandText.fillColor = brandColor
  if (sloganText) sloganText.fillColor = sloganColor
  if (parameters.gradient) {
    drawGradient("fill", instance, sloganColor, brandColor, instance.bounds.left, instance.bounds.right)
    instance.strokeScaling = true
    instance.strokeColor = null
    if (parameters.stroke) drawGradient("stroke", instance, brandColor, sloganColor, instance.bounds.left, instance.bounds.right)
    drawGradient("fill", brandText, brandColor, sloganColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, sloganText.bounds.left, sloganText.bounds.right)
  }
  else {
    instance.fillColor = sloganColor
    instance.strokeScaling = true
    instance.strokeColor = null
    if (instance.strokeWidth && parameters.stroke) instance.strokeColor = brandColor
  }

  // group.bounds.selected = true
  // brandText.selected = true
  // if (sloganText) sloganText.selected = true
  // instance.selected = true

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout006 = (params) => {
  let { asset, paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!asset) return generativeLayout002(params)
  cleanUpSVG(asset)
  parameters.stroke = false
  parameters.fill = true

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]
  if (!brandColor || !sloganColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }

  // *** Brand name ***
  let brandText = drawName(paper, typeface, logoName, null, width, height/2)
  brandText.bounds.center = (width/2, height/2)
  brandText.bounds.bottom = height
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text

  // *** Slogan ***
  let sloganText = null
  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, null, width, brandText.bounds.height)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.bottom = height
    brandText.bounds.bottom = sloganText.bounds.top - paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Symbol ***
  let instance = asset
  let symbolSpace = 2*group.bounds.height
  let widthScale = (group.bounds.width)/instance.bounds.width
  let heightScale = symbolSpace/instance.bounds.height
  instance.scale(Math.min(widthScale, heightScale))
  instance.bounds.right = group.bounds.left - paddingBetween
  instance.bounds.centerY = group.bounds.centerY
  instance.sendToBack()
  instance.name = "icon"
  group.addChild(instance)

  group.name = "logo"
  group.fitBounds(paper.view.bounds)

  if (brandText) brandText.fillColor = brandColor
  if (sloganText) sloganText.fillColor = sloganColor
  if (parameters.gradient) {
    drawGradient("fill", instance, sloganColor, brandColor, instance.bounds.left, instance.bounds.right)
    instance.strokeScaling = true
    instance.strokeColor = null
    if (parameters.stroke) drawGradient("stroke", instance, brandColor, sloganColor, instance.bounds.left, instance.bounds.right)
    drawGradient("fill", brandText, brandColor, sloganColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, sloganText.bounds.left, sloganText.bounds.right)
  }
  else {
    instance.fillColor = sloganColor
    instance.strokeScaling = true
    instance.strokeColor = null
    if (instance.strokeWidth && parameters.stroke) instance.strokeColor = brandColor
  }

  // brandText.selected = true
  // if (sloganText) sloganText.selected = true
  // instance.selected = true

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0061 = (params) => {
  let { asset, paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!asset) return generativeLayout002(params)
  cleanUpSVG(asset)
  parameters.stroke = false
  parameters.fill = true

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]
  if (!brandColor || !sloganColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }

  // *** Brand name ***
  let brandText = drawName(paper, typeface, logoName, null, width, height/2)
  brandText.bounds.center = (width/2, height/2)
  brandText.bounds.bottom = height
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let paddingBetween = brandText.bounds.height/3 // How much space between slogan and text

  // *** Slogan ***
  let sloganText = null
  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, null, width, 2*brandText.bounds.height/3)
    sloganText.bounds.left = brandText.bounds.left
    sloganText.bounds.bottom = height
    brandText.bounds.bottom = sloganText.bounds.top - paddingBetween
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Symbol ***
  let instance = asset
  let symbolSpace = 2*group.bounds.height
  let widthScale = (group.bounds.width)/instance.bounds.width
  let heightScale = symbolSpace/instance.bounds.height
  instance.scale(Math.min(widthScale, heightScale))
  instance.bounds.right = group.bounds.left - paddingBetween
  instance.bounds.centerY = group.bounds.centerY
  instance.sendToBack()
  instance.name = "icon"
  group.addChild(instance)

  group.name = "logo"
  group.fitBounds(paper.view.bounds)

  if (brandText) brandText.fillColor = brandColor
  if (sloganText) sloganText.fillColor = sloganColor
  if (parameters.gradient) {
    drawGradient("fill", instance, sloganColor, brandColor, instance.bounds.left, instance.bounds.right)
    instance.strokeScaling = true
    instance.strokeColor = null
    if (parameters.stroke) drawGradient("stroke", instance, brandColor, sloganColor, instance.bounds.left, instance.bounds.right)
    drawGradient("fill", brandText, brandColor, sloganColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, sloganText.bounds.left, sloganText.bounds.right)
  }
  else {
    instance.fillColor = sloganColor
    instance.strokeScaling = true
    instance.strokeColor = null
    if (instance.strokeWidth && parameters.stroke) instance.strokeColor = brandColor
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout007 = (params) => {
  let { asset, paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  if (!asset) return generativeLayout003(params)
  cleanUpSVG(asset)
  parameters.stroke = false
  parameters.fill = true

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]
  if (!brandColor || !sloganColor) {
    parameters.fill = false
    parameters.gradient = false
    parameters.stroke = true
  }

  // *** Brand name ***
  let nameMaxHeight = slogan ? height/3 : height/2
  let brandText = drawName(paper, typeface, logoName, null, width, nameMaxHeight)
  brandText.bounds.center = (width/2, height/2)
  brandText.bounds.top = 0
  brandText.name = "brand-name"
  let group = new paper.Group(brandText)

  let paddingBetween = slogan ? brandText.bounds.height/3 : brandText.bounds.height/2 // How much space between slogan and text
  paddingBetween = Math.floor(paddingBetween)
  // *** Slogan ***
  let sloganText = null
  if (slogan) {
    sloganText = drawName(paper, secondTypeface, slogan, null, width, 2*brandText.bounds.height/3)
    sloganText.bounds.centerX = width/2
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // *** Symbol ***
  let instance = asset
  let widthScale = width/instance.bounds.width
  let heightScale = (group.bounds.height*2)/instance.bounds.height
  instance.scale(Math.min(widthScale, heightScale))
  instance.bounds.center = (width/2, height/2)
  instance.bounds.top = brandText.bounds.bottom + paddingBetween
  instance.sendToBack()
  instance.name = "icon"
  if (slogan) sloganText.bounds.top = instance.bounds.bottom + paddingBetween

  group.addChild(instance)
  group.name = "logo"
  group.fitBounds(paper.view.bounds)
  group.bounds.centerX = width/2
  group.bounds.centerY = height/2

  if (brandText) brandText.fillColor = sloganColor
  if (sloganText) sloganText.fillColor = sloganColor
  if (parameters.gradient) {
    drawGradient("fill", instance, sloganColor, brandColor, instance.bounds.left, instance.bounds.right)
    instance.strokeScaling = true
    instance.strokeColor = null
    if (parameters.stroke) drawGradient("stroke", instance, brandColor, sloganColor, instance.bounds.left, instance.bounds.right)
    drawGradient("fill", brandText, brandColor, sloganColor, brandText.bounds.left, brandText.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, brandColor, sloganColor, sloganText.bounds.left, sloganText.bounds.right)
  }
  else {
    instance.fillColor = brandColor
    instance.strokeScaling = true
    instance.strokeColor = null
    if (instance.strokeWidth && parameters.stroke) instance.strokeColor = brandColor
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }
  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout008 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let firstLetter = logoName[0].toUpperCase()
  let lastLetter = null
  if (logoName.length > 1) lastLetter = logoName[logoName.length-1].toUpperCase()
  let middleName = []
  for (let i = 1; i < logoName.length-1; i++) middleName.push(logoName[i])
  let maxHeight = slogan ? height/3 : height
  let brandText = middleName.length ? drawName(paper, typeface, middleName, brandColor, 2*width/3, maxHeight) : null
  maxHeight = brandText ? brandText.bounds.height*2 : maxHeight
  let maxWidth = width// brandText ? (width - brandText.bounds.width)/2 : width/3
  let firstText = drawName(paper, typeface, firstLetter, brandColor, maxWidth, maxHeight)
  let lastText = lastLetter ? drawName(paper, typeface, lastLetter, brandColor, maxWidth, maxHeight) : null
  if (brandText) {
    brandText.bounds.center = (width/2, height/2)
    firstText.bounds.center = (width/2, height/2)
    lastText.bounds.center = (width/2, height/2)
    // firstText.bounds.top = brandText.bounds.top
    // lastText.bounds.top = brandText.bounds.top
    firstText.bounds.right = brandText.bounds.left - brandText.bounds.height/7
    lastText.bounds.left = brandText.bounds.right + brandText.bounds.height/7
  }
  else if (lastText) {
    lastText.bounds.left = firstText.bounds.right + firstText.bounds.height/7
  }

  let brandGroup = new paper.Group(firstText)
  if (firstText) brandGroup.addChild(firstText)
  if (brandText) brandGroup.addChild(brandText)
  if (lastText) brandGroup.addChild(lastText)
  brandGroup.name = "brand-name"

  let group = new paper.Group(brandGroup)
  group.addChild(brandGroup)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandGroup.bounds.height/7 // How much space between slogan and text
    let maxWidth = brandText ? brandText.bounds.width - paddingBetween : width
    if (logoName.length < 4) maxWidth = width
    maxHeight = brandGroup.bounds.height //brandText ? brandText.bounds.height : brandGroup.bounds.height
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor, maxWidth, maxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText ? brandText.bounds.bottom + paddingBetween : firstText.bounds.bottom + paddingBetween
    if (logoName.length < 4) {
      sloganText.bounds.top = brandGroup.bounds.bottom + paddingBetween
      sloganText.bounds.left = firstText.bounds.right
    }
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // // Centralize and scale both
  group.fitBounds(paper.view.bounds)
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    if (firstText) drawGradient("fill", firstText, brandColor, sloganColor, brandGroup.bounds.left, brandGroup.bounds.right)
    if (brandText) drawGradient("fill", brandText, brandColor, sloganColor, brandGroup.bounds.left, brandGroup.bounds.right)
    if (lastText) drawGradient("fill", lastText, brandColor, sloganColor, brandGroup.bounds.left, brandGroup.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, sloganColor, brandColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0081 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let firstLetter = logoName[0].toUpperCase()
  let middleName = []
  for (let i = 1; i < logoName.length; i++) middleName.push(logoName[i])
  let maxHeight = slogan ? height/3 : height
  let brandText = middleName.length ? drawName(paper, typeface, middleName, brandColor, 2*width/3, maxHeight) : null
  maxHeight = brandText ? brandText.bounds.height*2 : maxHeight
  let maxWidth = width// brandText ? (width - brandText.bounds.width)/2 : width/3
  let firstText = drawName(paper, typeface, firstLetter, brandColor, maxWidth, maxHeight)
  if (brandText) {
    brandText.bounds.center = (width/2, height/2)
    firstText.bounds.center = (width/2, height/2)
    // firstText.bounds.top = brandText.bounds.top
    firstText.bounds.right = brandText.bounds.left - brandText.bounds.height/7
  }

  let brandGroup = new paper.Group(firstText)
  if (firstText) brandGroup.addChild(firstText)
  if (brandText) brandGroup.addChild(brandText)
  brandGroup.name = "brand-name"

  let group = new paper.Group(brandGroup)
  group.addChild(brandGroup)

  // Slogan
  let sloganText = null
  if (slogan) {
    let paddingBetween = brandGroup.bounds.height/7 // How much space between slogan and text
    let maxWidth = brandText ? brandText.bounds.width - paddingBetween : width
    if (logoName.length < 4) maxWidth = width
    maxHeight = brandGroup.bounds.height //brandText ? brandText.bounds.height : brandGroup.bounds.height
    sloganText = drawName(paper, secondTypeface, slogan, sloganColor, maxWidth, maxHeight)
    sloganText.bounds.centerX = width/2
    sloganText.bounds.top = brandText ? brandText.bounds.bottom + paddingBetween : firstText.bounds.bottom + paddingBetween
    if (logoName.length < 4) {
      sloganText.bounds.top = brandGroup.bounds.bottom + paddingBetween
      sloganText.bounds.left = firstText.bounds.right
    }
    sloganText.name = "brand-slogan"
    group.addChild(sloganText)
  }

  // // Centralize and scale both
  group.fitBounds(paper.view.bounds)
  group.bounds.center = (width/2, height/2)
  group.name = "logo"

  if (parameters.gradient) {
    if (firstText) drawGradient("fill", firstText, brandColor, sloganColor, brandGroup.bounds.left, brandGroup.bounds.right)
    if (brandText) drawGradient("fill", brandText, brandColor, sloganColor, brandGroup.bounds.left, brandGroup.bounds.right)
    if (sloganText) drawGradient("fill", sloganText, sloganColor, brandColor, group.bounds.left, group.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout009 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters, asset } = params

  if (!asset) return generativeLayout001(params)
  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let circle = new paper.Path.Circle({
    center: [width/2, height/2],
    radius: width/2,
    strokeColor: null // "blue"
  })

  let brandLetter = []
  let groupBrandText = new paper.Group()
  let offsets = [0]
  let biggestHeightBrand = 0
  let biggestWidthBrand = 0
  let spaceBetweenWords = 0
  for (let i = 0; i < logoName.length; i++) {
    if (i > 0 && offsets[i-1] > 1210) break
    let path = typeface.getPath(logoName[i].toUpperCase(), width/2, height/2, Math.max(10, 360/logoName.length))
    brandLetter.push(new paper.CompoundPath(path.toPathData()))
    brandLetter[i].fillColor = brandColor
    brandLetter[i].strokeWidth = 0
    brandLetter[i].name = "brand-name"
    // if (i > 0 && spaceBetweenWords === 0) spaceBetweenWords = brandLetter[i-1].bounds.width
    if (i > 0 && spaceBetweenWords === 0) spaceBetweenWords = Math.max(8, 360/logoName.length)
    if (i > 0) offsets[i] = offsets[i-1] + brandLetter[i].bounds.width + spaceBetweenWords
    // if (brandLetter[i].bounds.width === 0 ) offsets[i] = offsets[i-1] + 2*brandLetter[i-1].bounds.width
    let tan = circle.getTangentAt(offsets[i])
    brandLetter[i].bounds.center = circle.getPointAt(offsets[i])
    if (tan) brandLetter[i].rotation = tan.angle
    if (biggestHeightBrand < brandLetter[i].bounds.height) biggestHeightBrand = brandLetter[i].bounds.height
    if (biggestWidthBrand < brandLetter[i].bounds.width) biggestWidthBrand = brandLetter[i].bounds.width
    groupBrandText.addChild(brandLetter[i])
  }

  // groupBrandText.bounds.selected = true
  let difY = groupBrandText.firstChild.bounds.center.y - groupBrandText.lastChild.bounds.center.y
  let difX = groupBrandText.firstChild.bounds.center.x - groupBrandText.lastChild.bounds.center.x
  let angle = (Math.atan2(difX, difY) * 180 / Math.PI) + 90
  groupBrandText.rotate(angle, paper.view.center)
  groupBrandText.bounds.centerX = width/2

  let group = new paper.Group()
  group.addChild(groupBrandText)

  if (logoName.length < 3) biggestHeightBrand = groupBrandText.bounds.bottom
  let symbolHeightSpace = (height - biggestHeightBrand)
  let symbolWidthSpace = (logoName.length < 3) ? width : (width - biggestWidthBrand)

  let groupSloganText = null
  let biggestHeightSlogan = 0
  let biggestWidthSlogan = 0
  spaceBetweenWords = 0
  if (slogan && groupBrandText.bounds.bottom < 9*height/10) {
    let pathSlogan = new paper.Path.Arc({
      from: new paper.Point(0, groupBrandText.bounds.bottom),
      through: new paper.Point(width/2, height),
      to: new paper.Point(width, groupBrandText.bounds.bottom),
      strokeColor: null // "red"
    })

    let sloganLetter = []
    groupSloganText = new paper.Group()
    offsets = [0]
    for (let i = 0; i < slogan.length; i++) {
      let path = secondTypeface.getPath(slogan[i].toUpperCase(), width/2, height/2, Math.max(8, 360/slogan.length))
      sloganLetter.push(new paper.CompoundPath(path.toPathData()))
      sloganLetter[i].fillColor = brandColor
      sloganLetter[i].strokeWidth = 0
      // if (i > 0 && spaceBetweenWords === 0) spaceBetweenWords = Math.max(8, sloganLetter[i-1].bounds.width)
      if (i > 0 && spaceBetweenWords === 0) spaceBetweenWords = Math.max(8, 360/slogan.length)
      if (i > 0) offsets[i] = offsets[i-1] + sloganLetter[i].bounds.width/2 + spaceBetweenWords //sloganLetter[i-1].bounds.width
      // if (sloganLetter[i].bounds.width === 0 ) offsets[i] = offsets[i-1] + 2*sloganLetter[i-1].bounds.width
      if (!pathSlogan.getPointAt(offsets[i])) {
        sloganLetter[i].remove()
        groupSloganText.removeChildren()
        groupSloganText.remove()
        groupSloganText = null
        break
      }
      let tan = pathSlogan.getTangentAt(offsets[i])
      sloganLetter[i].bounds.center = pathSlogan.getPointAt(offsets[i])
      if (tan) sloganLetter[i].rotation = tan.angle
      if (biggestHeightSlogan < sloganLetter[i].bounds.height) biggestHeightSlogan = sloganLetter[i].bounds.height
      if (biggestWidthSlogan < sloganLetter[i].bounds.width) biggestWidthSlogan = sloganLetter[i].bounds.width
      sloganLetter[i].name = "brand-slogan"
      groupSloganText.addChild(sloganLetter[i])
    }
    if (groupSloganText) {
      // groupSloganText.bounds.selected = true
      let difY = groupSloganText.firstChild.bounds.center.y - groupSloganText.lastChild.bounds.center.y
      let difX = groupSloganText.firstChild.bounds.center.x - groupSloganText.lastChild.bounds.center.x
      angle = (Math.atan2(difX, difY) * 180 / Math.PI) + 90
      groupSloganText.rotate(angle, paper.view.center)
      groupSloganText.bounds.centerX = width/2
      group.addChild(groupSloganText)

      symbolHeightSpace = (symbolHeightSpace - biggestHeightSlogan)
      symbolWidthSpace = (symbolWidthSpace - biggestWidthSlogan)
    }
  }

  let paddingBrand = (logoName.length < 3) ? biggestHeightBrand : biggestHeightBrand/2
  if (logoName.length < 3 && !groupSloganText) paddingBrand += groupBrandText.bounds.height/7
  let centerY = paddingBrand + (height - paddingBrand)/2
  if (groupSloganText) centerY = paddingBrand + (height - (biggestHeightSlogan/2 + paddingBrand))/2
  // let rectangle = new paper.Path.Rectangle({
  //   center: [width/2, centerY],
  //   size: [symbolWidthSpace, symbolHeightSpace],
  //   strokeColor: null // "red"
  // })

  let instance = asset
  if (instance) {
    cleanUpSVG(instance)
    instance.bounds.center = paper.view.bounds.center
    // if (groupSloganText) groupSloganText.bounds.selected = true
    // groupBrandText.bounds.selected = true
    instance.bounds.centerY = centerY
    let widthScale = (2*symbolWidthSpace/3)/instance.bounds.width
    let heightScale = groupSloganText ? (2*symbolHeightSpace/3)/instance.bounds.height : symbolHeightSpace/instance.bounds.height
    instance.scale(Math.min(widthScale, heightScale))
    instance.sendToBack()
    instance.name = "icon"
    group.addChild(instance)
  }

  // group.fitBounds(paper.view.bounds)
  let widthScale = (width-4)/group.bounds.width
  let heightScale = (height-4)/group.bounds.height
  group.scale(Math.min(widthScale, heightScale))
  group.bounds.center = paper.view.center

  if (parameters.gradient) {
    drawGradient("fill", groupBrandText, brandColor, sloganColor, groupBrandText.bounds.left, groupBrandText.bounds.right)
    if (groupSloganText) drawGradient("fill", groupSloganText, brandColor, sloganColor, groupSloganText.bounds.left, groupSloganText.bounds.right)
    if (instance) {
      drawGradient("fill", instance, sloganColor, brandColor, instance.bounds.left, instance.bounds.right)
      instance.strokeScaling = true
      instance.strokeColor = null
      if (parameters.stroke) drawGradient("stroke", instance, brandColor, sloganColor, instance.bounds.left, instance.bounds.right)
    }
  }
  else if (instance) {
    instance.fillColor = sloganColor
    instance.strokeScaling = true
    instance.strokeColor = null
    if (instance.strokeWidth && parameters.stroke) instance.strokeColor = brandColor
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0091 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let rng = seedrandom(logoName+slogan)
  let pathBrand = new paper.Path()
  // pathBrand.strokeColor = 'red'
  pathBrand.segments = []
  pathBrand.add(0, Math.floor(rng()*height/4))
  let numberPoints = 3
  for (var i = 1; i < numberPoints+1; i++) {
    let point = new paper.Point(width / numberPoints * i, Math.floor(rng()*height/4));
    pathBrand.add(point);
  }
  pathBrand.add(width*4, Math.floor(rng()*height/4))
  pathBrand.smooth()

  let brandLetter = []
  let groupBrandText = new paper.Group()
  let offsets = [0]
  let spaceBetweenWords = Math.max(8, 360/logoName.length)
  for (let i = 0; i < logoName.length; i++) {
    if (i > 0 && offsets[i-1] > 1210) break
    let path = typeface.getPath(logoName[i].toUpperCase(), width/2, height/2, Math.max(10, 360/logoName.length))
    brandLetter.push(new paper.CompoundPath(path.toPathData()))
    brandLetter[i].fillColor = brandColor
    brandLetter[i].strokeWidth = 0
    brandLetter[i].name = "brand-name"
    if (i > 0) offsets[i] = offsets[i-1] + brandLetter[i].bounds.width + spaceBetweenWords
    let tan = pathBrand.getTangentAt(offsets[i])
    brandLetter[i].bounds.center = pathBrand.getPointAt(offsets[i])
    if (tan) brandLetter[i].rotation = tan.angle
    groupBrandText.addChild(brandLetter[i])
  }

  let group = new paper.Group()
  group.addChild(groupBrandText)

  let groupSloganText = null
  if (slogan) {
    spaceBetweenWords = Math.max(8, 360/slogan.length)
    let sloganLetter = []
    groupSloganText = new paper.Group()
    offsets = [0]
    for (let i = 0; i < slogan.length; i++) {
      let path = secondTypeface.getPath(slogan[i].toUpperCase(), width/2, height/2, Math.max(8, 360/slogan.length))
      sloganLetter.push(new paper.CompoundPath(path.toPathData()))
      sloganLetter[i].fillColor = sloganColor
      sloganLetter[i].strokeWidth = 0
      if (i > 0) offsets[i] = offsets[i-1] + sloganLetter[i].bounds.width/2 + spaceBetweenWords
      if (!pathBrand.getPointAt(offsets[i])) {
        sloganLetter[i].remove()
        groupSloganText.removeChildren()
        groupSloganText.remove()
        groupSloganText = null
        break
      }
      let tan = pathBrand.getTangentAt(offsets[i])
      sloganLetter[i].bounds.center = pathBrand.getPointAt(offsets[i])
      if (tan) sloganLetter[i].rotation = tan.angle
      sloganLetter[i].name = "brand-slogan"
      groupSloganText.addChild(sloganLetter[i])
    }
    if (groupSloganText) {
      groupSloganText.bounds.top = groupBrandText.bounds.bottom + groupBrandText.bounds.height/10
      group.addChild(groupSloganText)
    }
  }

  group.fitBounds(paper.view.bounds)

  if (parameters.gradient) {
    drawGradient("fill", groupBrandText, brandColor, sloganColor, groupBrandText.bounds.left, groupBrandText.bounds.right)
    if (groupSloganText) drawGradient("fill", groupSloganText, brandColor, sloganColor, groupSloganText.bounds.left, groupSloganText.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}
//****************************************************************************//
export const generativeLayout0092 = (params) => {
  let { paper, width, height, logoName, colorPalette, typeface, secondTypeface, slogan, parameters } = params

  let brandColor = colorPalette[0]
  let sloganColor = colorPalette[1] || colorPalette[0]

  // Brand name
  let rng = seedrandom(logoName+slogan)
  let pathBrand = new paper.Path()
  // pathBrand.strokeColor = 'red'
  pathBrand.segments = []
  pathBrand.add(0, Math.floor(rng()*height/3))
  let numberPoints = 2
  for (var i = 1; i < numberPoints+1; i++) {
    let point = new paper.Point(width / numberPoints * i, Math.floor(rng()*height/3));
    pathBrand.add(point);
  }
  pathBrand.add(width*4, Math.floor(rng()*height/3))
  pathBrand.smooth()

  let brandLetter = []
  let groupBrandText = new paper.Group()
  let offsets = [0]
  let spaceBetweenWords = Math.max(8, 240/logoName.length) // 0
  for (let i = 0; i < logoName.length; i++) {
    if (i > 0 && offsets[i-1] > 1210) break
    let path = typeface.getPath(logoName[i].toUpperCase(), width/2, height/2, Math.max(10, 240/logoName.length))
    brandLetter.push(new paper.CompoundPath(path.toPathData()))
    brandLetter[i].fillColor = sloganColor
    brandLetter[i].strokeWidth = 0
    brandLetter[i].name = "brand-name"
    if (i > 0 && spaceBetweenWords === 0) spaceBetweenWords = Math.max(10, brandLetter[i-1].bounds.width)
    if (i > 0) offsets[i] = offsets[i-1] + brandLetter[i].bounds.width + spaceBetweenWords
    let tan = pathBrand.getTangentAt(offsets[i])
    brandLetter[i].bounds.center = pathBrand.getPointAt(offsets[i])
    if (tan) brandLetter[i].rotation = tan.angle
    groupBrandText.addChild(brandLetter[i])
  }

  let group = new paper.Group()
  group.addChild(groupBrandText)

  let groupSloganText = null
  if (slogan) {
    spaceBetweenWords =  Math.max(8, 240/slogan.length)
    let sloganLetter = []
    groupSloganText = new paper.Group()
    offsets = [0]
    for (let i = 0; i < slogan.length; i++) {
      let path = secondTypeface.getPath(slogan[i].toUpperCase(), width/2, height/2, Math.max(8, 240/slogan.length))
      sloganLetter.push(new paper.CompoundPath(path.toPathData()))
      sloganLetter[i].fillColor = brandColor
      sloganLetter[i].strokeWidth = 0
      if (i > 0 && spaceBetweenWords === 0) spaceBetweenWords = Math.max(10, sloganLetter[i-1].bounds.width)
      if (i > 0) offsets[i] = offsets[i-1] + sloganLetter[i].bounds.width/2 + spaceBetweenWords
      if (!pathBrand.getPointAt(offsets[i])) {
        sloganLetter[i].remove()
        groupSloganText.removeChildren()
        groupSloganText.remove()
        groupSloganText = null
        break
      }
      let tan = pathBrand.getTangentAt(offsets[i])
      sloganLetter[i].bounds.center = pathBrand.getPointAt(offsets[i])
      if (tan) sloganLetter[i].rotation = tan.angle
      sloganLetter[i].name = "brand-slogan"
      groupSloganText.addChild(sloganLetter[i])
    }
    if (groupSloganText) {
      groupSloganText.bounds.top = groupBrandText.bounds.bottom + groupBrandText.bounds.height/3
      group.addChild(groupSloganText)
    }
  }

  group.fitBounds(paper.view.bounds)

  if (parameters.gradient) {
    drawGradient("fill", groupBrandText, brandColor, sloganColor, groupBrandText.bounds.left, groupBrandText.bounds.right)
    if (groupSloganText) drawGradient("fill", groupSloganText, brandColor, sloganColor, groupSloganText.bounds.left, groupSloganText.bounds.right)
  }

  // Background
  if (bgColor) {
    let bg = drawBG(paper, width, height, bgColor)
    bg.sendToBack()
  }

  paper.view.draw()
}



// WEBPACK FOOTER //
// ./src/layoutProcedures.js